// if window is undefined, we are on the server
export const checkIfSSR = (): boolean => {
	if (typeof window === 'undefined') {
		return true;
	}
	return false;
};
